/**
 * Constants used througout the application.
 */

const ROLES = {
  ADMIN: 'ADMIN', // Technical admin
  USER: 'USER',
  // MANAGER: "manager",  // User admin
  // SUPPLIER: "supplier",
  // AGENCY: "agency",
  // PACKAGING: "packaging",
}

export { ROLES }
